<div class="page administracion-asociaciones">
    <app-page-header titulo="Administración de asociaciones" icono="bi-toggles" seccion="admin"
        descripcion="Activa o desactiva asociaciones. Una asociación desactivada no puede iniciar sesión y su sesión abierta pierde el acceso. No se borra ningún dato. Cada cambio queda registrado en la auditoría.">
        <button type="button" class="btn btn-outline-secondary" (click)="cargar()" [disabled]="cargando || trabajando">
            <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>Actualizar
        </button>
    </app-page-header>

    @if (cargando && !asociaciones.length) {
        <app-spinner [fullscreen]="false"></app-spinner>
    } @else if (error) {
        <div class="state-panel state-panel--error" role="alert">
            <i class="bi bi-exclamation-octagon-fill state-panel__icon" aria-hidden="true"></i>
            <p class="state-panel__text">{{ error }}</p>
            <button type="button" class="btn btn-outline-danger btn-sm" (click)="cargar()"><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>Reintentar</button>
        </div>
    } @else {
        <section class="panel" aria-label="Filtros">
            <div class="toolbar">
                <div class="toolbar-wide">
                    <label class="form-label" for="adm-busqueda">Buscar por nombre o CIF</label>
                    <div class="search-field">
                        <i class="bi bi-search" aria-hidden="true"></i>
                        <input id="adm-busqueda" class="form-control" type="search" data-testid="busqueda" placeholder="Nombre o CIF" autocomplete="off" [(ngModel)]="busqueda" (ngModelChange)="aplicarFiltros()">
                    </div>
                </div>
                <div>
                    <label class="form-label" for="adm-estado">Estado</label>
                    <select id="adm-estado" class="form-select" data-testid="filtro-estado" [(ngModel)]="filtroEstado" (ngModelChange)="aplicarFiltros()">
                        <option value="todos">Todos</option>
                        <option value="activa">Activas</option>
                        <option value="desactivada">Desactivadas</option>
                        <option value="sin-definir">Sin definir</option>
                    </select>
                </div>
                <div>
                    <label class="form-label" for="adm-tipo">Tipo de asociación</label>
                    <select id="adm-tipo" class="form-select" data-testid="filtro-tipo" [(ngModel)]="filtroTipo" (ngModelChange)="aplicarFiltros()">
                        <option value="">Todos los tipos</option>
                        @for (t of tipos; track t.id) { <option [ngValue]="t.id">{{ t.tipo }}</option> }
                    </select>
                </div>
            </div>
        </section>

        <section class="panel selection-bar" aria-label="Acciones sobre la selección">
            <span data-testid="contador-seleccion"><strong>{{ seleccion.size }}</strong> seleccionada(s) de {{ filtradas.length }} mostradas (máx. {{ LOTE_MAX }} por operación)</span>
            <span class="cluster ms-auto">
                <button type="button" class="btn btn-outline-success btn-sm" data-testid="activar-seleccionadas" [disabled]="!seleccion.size || trabajando" (click)="iniciar('activar')"><i class="bi bi-check-circle" aria-hidden="true"></i>Activar seleccionadas</button>
                <button type="button" class="btn btn-outline-danger btn-sm" data-testid="desactivar-seleccionadas" [disabled]="!seleccion.size || trabajando" (click)="iniciar('desactivar')"><i class="bi bi-slash-circle" aria-hidden="true"></i>Desactivar seleccionadas</button>
                <button type="button" class="btn btn-link btn-sm" data-testid="limpiar-seleccion" [disabled]="!seleccion.size || trabajando" (click)="limpiarSeleccion()">Limpiar selección</button>
            </span>
        </section>

        @if (previa) {
            <section class="panel panel--warning" aria-labelledby="titulo-previa" data-testid="previa">
                <h2 id="titulo-previa" class="step-title"><span class="step-number" aria-hidden="true"><i class="bi bi-eye"></i></span>Vista previa: {{ accion === 'desactivar' ? 'DESACTIVAR' : 'ACTIVAR' }} {{ previa.resumen.seleccionadas }} asociación(es)</h2>
                <p class="summary-callout" data-testid="previa-resumen">
                    Se modificarán exactamente <strong>{{ previa.resumen.cambiaran }}</strong> asociación(es);
                    sin cambios: {{ previa.resumen.sinCambios }}; con error: {{ previa.resumen.errores }}.
                </p>
                @if (accion === 'desactivar' && previa.resumen.cambiaran > 0) {
                    <div class="alert alert-danger" role="alert">
                        Las asociaciones desactivadas <strong>dejarán de poder iniciar sesión</strong> (contraseña y QR) y perderán el acceso de sus sesiones abiertas.
                    </div>
                }
                <div class="table-wrap table-bordered-wrap mb-3" style="max-height: 280px; overflow-y: auto;" tabindex="0" role="region" aria-label="Vista previa de la operación (desplazable)">
                    <table class="table table-sm align-middle table-stack">
                        <thead><tr><th scope="col">Asociación</th><th scope="col">CIF</th><th scope="col">Estado actual</th><th scope="col">Resultado</th></tr></thead>
                        <tbody>
                            @for (i of previa.items; track i.id) {
                                <tr [class.table-danger]="i.resultado === 'error'" [class.table-warning]="i.resultado === 'cambiara'">
                                    <td data-label="Asociación">{{ i.nombre || ('Id ' + i.id) }}</td>
                                    <td data-label="CIF">{{ i.cif || '—' }}</td>
                                    <td data-label="Estado actual">{{ etiquetaEstadoNumero(i.anterior) }}</td>
                                    <td data-label="Resultado">{{ etiquetaResultado(i) }}@if (i.motivo) { <span class="small d-block text-muted">{{ i.motivo }}</span> }</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
                @if (previa.resumen.cambiaran > 0) {
                    <div class="form-grid">
                        <div>
                            <label class="form-label" for="adm-motivo">Motivo (opcional, queda en la auditoría)</label>
                            <input id="adm-motivo" class="form-control" maxlength="255" data-testid="motivo" [(ngModel)]="motivo">
                        </div>
                        <div>
                            <label class="form-label" for="adm-confirmacion">Para confirmar, escribe exactamente <code data-testid="frase">{{ previa.confirmacion }}</code></label>
                            <input id="adm-confirmacion" class="form-control" autocomplete="off" data-testid="confirmacion" [(ngModel)]="confirmacionTexto">
                        </div>
                    </div>
                } @else {
                    <p class="small text-muted mb-0">No hay nada que cambiar con esta selección.</p>
                }
                <div class="form-actions mt-3">
                    <button type="button" class="btn" data-testid="ejecutar" [ngClass]="accion === 'desactivar' ? 'btn-danger' : 'btn-success'" [disabled]="!confirmacionValida || trabajando" (click)="ejecutar()">
                        Aplicar a {{ previa.resumen.cambiaran }} asociación(es)
                    </button>
                    <button type="button" class="btn btn-outline-secondary" data-testid="cancelar" [disabled]="trabajando" (click)="cancelar()">Cancelar</button>
                </div>
            </section>
        }

        @if (resultado) {
            <section class="panel panel--success" aria-labelledby="titulo-resultado" data-testid="resultado">
                <h2 id="titulo-resultado" class="step-title"><span class="step-number step-number--ok" aria-hidden="true"><i class="bi bi-check-lg"></i></span>Resultado de la operación</h2>
                <p class="summary-callout">
                    Aplicadas: <strong>{{ resultado.resumen.aplicadas }}</strong> · sin cambios: {{ resultado.resumen.sinCambios }} · errores: {{ resultado.resumen.errores }}
                    <span class="text-muted small d-block">Operación de auditoría: {{ resultado.operacion }}</span>
                </p>
                <ul class="small mb-0">
                    @for (i of resultado.items; track i.id) {
                        <li [class.text-danger]="i.resultado === 'error'">{{ i.nombre || ('Id ' + i.id) }} — {{ etiquetaResultado(i) }}@if (i.motivo) { ({{ i.motivo }}) }</li>
                    }
                </ul>
            </section>
        }

        <section class="panel panel--flush" aria-label="Listado de asociaciones">
            <div class="table-wrap" tabindex="0" role="region" aria-label="Listado de asociaciones (desplazable)">
                <table class="table table-hover align-middle">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 2.75rem;">
                                <input type="checkbox" class="form-check-input" aria-label="Seleccionar las asociaciones de esta página" data-testid="seleccionar-pagina" [checked]="paginaTodaSeleccionada" (change)="alternarPagina()">
                            </th>
                            <th scope="col">Asociación</th><th scope="col">CIF</th><th scope="col">Tipo</th><th scope="col">Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (a of paginaActual; track a.id) {
                            <tr [class.table-active]="estaSeleccionada(a)" data-testid="fila">
                                <td><input type="checkbox" class="form-check-input" [attr.aria-label]="'Seleccionar ' + a.nombre" [checked]="estaSeleccionada(a)" (change)="alternar(a)"></td>
                                <td><a [routerLink]="['/asociaciones', a.id]">{{ a.nombre }}</a></td>
                                <td>{{ a.cif || '—' }}</td>
                                <td>{{ tipoNombre(a['tipo_asociacion']) }}</td>
                                <td>
                                    <span class="badge" data-testid="estado-fila" [ngClass]="estadoDe(a) === 'activa' ? 'bg-success' : estadoDe(a) === 'desactivada' ? 'bg-danger' : 'bg-secondary'">{{ ETIQUETA_ESTADO[estadoDe(a)] }}</span>
                                </td>
                            </tr>
                        } @empty {
                            <tr><td colspan="5" class="empty-inline">No hay asociaciones que coincidan con los filtros.</td></tr>
                        }
                    </tbody>
                </table>
            </div>
            <div class="table-footer">
                <span class="small text-muted">{{ filtradas.length }} asociación(es)</span>
                <nav class="cluster" aria-label="Paginación de asociaciones">
                    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="pagina <= 1" (click)="irA(pagina - 1)"><i class="bi bi-chevron-left" aria-hidden="true"></i>Anterior</button>
                    <span class="small">Página {{ pagina }} de {{ totalPaginas }}</span>
                    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="pagina >= totalPaginas" (click)="irA(pagina + 1)">Siguiente<i class="bi bi-chevron-right" aria-hidden="true"></i></button>
                </nav>
            </div>
        </section>
    }
</div>
